var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"opple-config-navBar"},_vm._l((_vm.relationAction),function(item,index){return _c('div',{key:index,staticClass:"opple-config-navBar_item",class:{active: _vm.currentTab === index},on:{"click":() => _vm.onItemClick(index)}},[_vm._v(" "+_vm._s(item.Name)+" ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }